// extracted by mini-css-extract-plugin
export default {"rating":"MA-z","numberOfStars":"NA-z","count":"OA-z","barGraphSpacing":"PA-z","barGraph":"QA-z"};